import { UseQueryResult } from '@tanstack/react-query';
import { ApiResponse } from 'apisauce';
import { Grid } from '@mui/material';
import { GridColDef, GridRowParams } from '@mui/x-data-grid';

import { DataGrid, QueryRenderer } from '@barboxx/admin-components';
import { Place } from '@barboxx/models';

const columns: GridColDef[] = [
    { field: 'name', headerName: 'Name', width: 200, flex: 1, sortable: false },
    {
        field: 'streetAddress',
        headerName: 'Address',
        width: 300,
        flex: 1,
        sortable: false,
    },
    { field: 'city', headerName: 'City', width: 200, sortable: false },
    { field: 'state', headerName: 'State', width: 100, sortable: false },
    { field: 'zip', headerName: 'Zip Code', width: 100, sortable: false },
    {
        field: 'enabled',
        headerName: 'Enabled',
        type: 'boolean',
        width: 100,
        sortable: false,
    },
    {
        field: 'category',
        headerName: 'Type',
        width: 100,
        sortable: false,
    },
];

interface Props {
    possiblePlaces: UseQueryResult<ApiResponse<Place.SearchResponse>>;
    onSelectPlace: (id: string) => void;
}

export function LocalPlaceTable({ possiblePlaces, onSelectPlace }: Props) {
    const handleRowClick = (data: GridRowParams) => {
        onSelectPlace(data.id as string);
    };

    return (
        <QueryRenderer results={possiblePlaces}>
            {data => (
                <Grid container flex={1} marginY={2}>
                    <DataGrid
                        disableColumnFilter
                        autoHeight
                        rows={data.results ?? []}
                        columns={columns}
                        disableRowSelectionOnClick
                        disableColumnMenu
                        hideFooter
                        onRowClick={handleRowClick}
                    />
                </Grid>
            )}
        </QueryRenderer>
    );
}
